<template>
  <div>
    <v-row align="center" justify="space-between" class="mb-2 mt-2" v-if="$root.Permissions.admin()">
      <v-col cols="12" md="11">
        <v-row no-gutters align="center">
          <div cols="12" md="2" class="pt-0">
            <v-autocomplete
              class="ml-2"
              :menu-props="{ offsetY: true}"
              v-model="distribuidor"
              :items="distribuidores"
              hide-details=""
              clearable
              clear-icon="close"
              label="Distribuidor"
              append-icon="expand_more"
              outlined
              @change="applyFilter()"
              @click:clear="applyFilter()"
            >
            </v-autocomplete>
          </div>
          <div cols="12" md="2" class="pt-0">
            <v-autocomplete
              class="ml-2"
              :menu-props="{ offsetY: true}"
              v-model="integrador"
              :items="integradores"
              hide-details=""
              clearable
              clear-icon="close"
              label="Integrador"
              append-icon="expand_more"
              outlined
              @change="applyFilter()"
              @click:clear="applyFilter()"
            >
            </v-autocomplete>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-2" v-if="loadingRelatorio">
      <v-col cols="12" sm="4" md="4" lg="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="sentences" class="mb-3"></v-skeleton-loader>
        <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader type="table-thead" class="mb-3"></v-skeleton-loader>
        <v-skeleton-loader type="table-tbody" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mt-1 mb-0 px-1" v-if="!loadingRelatorio">
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            Por usuário responsável
          </div>
          <doughnut-chart
            v-if="!loadingGraficoPorUsuario && !!doughnutChartDataUsuario && !!doughnutChartDataUsuario.labels && doughnutChartDataUsuario.labels.length"
            :options="doughnutChartOption"
            :height="300"
            :data="doughnutChartDataUsuario">
          </doughnut-chart>
          <div class="w-100" v-else>
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" v-if="status !== 2">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            Por valor total
          </div>
          <doughnut-chart
            v-if="!loadingGraficoPorValor && !!doughnutChartDataValorTotal && !!doughnutChartDataValorTotal.labels && doughnutChartDataValorTotal.labels.length"
            :options="doughnutChartOption"
            :height="300"
            :data="doughnutChartDataValorTotal">
          </doughnut-chart>
          <div class="w-100" v-else>
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" v-if="status === 1">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            Por chance de fechar
          </div>
          <doughnut-chart
            v-if="!loadingGraficoPorChance && !!doughnutChartDataChance && !!doughnutChartDataChance.labels && doughnutChartDataChance.labels.length"
            :options="doughnutChartOption"
            :height="300"
            :data="doughnutChartDataChance">
          </doughnut-chart>
          <div class="w-100" v-else>
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" v-if="status === 2">
        <v-card elevation="2" class="px-3 pt-3 pb-4 h-100">
          <div class="text-h2 text-center mb-2">
            Por motivo
          </div>
          <doughnut-chart
            v-if="!loadingGraficoPorMotivo && !!doughnutChartDataMotivo && !!doughnutChartDataMotivo.labels && doughnutChartDataMotivo.labels.length"
            :options="doughnutChartOption"
            :height="300"
            :data="doughnutChartDataMotivo">
          </doughnut-chart>
          <div class="w-100" v-else>
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" v-if="status !== 1">
        <v-card elevation="2" class="px-3 pt-3 pb-4 h-100">
          <div class="text-h2 text-center mb-2" v-if="status === 2">
            Tempo médio até perder a venda
          </div>
          <div class="text-h2 text-center mb-2" v-else>
            Tempo médio até fechar a venda
          </div>
          <bar-chart
            v-if="!loadingGraficoPorTempo && !!chartDataTempo && !!chartDataTempo.labels && chartDataTempo.labels.length"
            :options="optionsChart"
            :height="200"
            :data="chartDataTempo">
          </bar-chart>
          <div class="w-100" v-else>
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <v-data-table
            :headers="headersUsers"
            :items="dadosUsers"
            multi-sort
            loading-text="Carregando... Por favor aguarde"
            :loading="loadingTabela"
            class="elevation-1 base_table mt-4"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:item.chances="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip label v-bind="attrs" v-on="on" color="success" text-color="white">
                    {{item.chance_bom}}
                  </v-chip>
                </template>
                <span>Chance boa</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip label v-bind="attrs" v-on="on" color="error" class="mx-1" text-color="white">
                    {{item.chance_baixa}}
                  </v-chip>
                </template>
                <span>Chance baixa</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip label v-bind="attrs" v-on="on" color="blue" text-color="white">
                    {{item.chance_medio}}
                  </v-chip>
                </template>
                <span>Chance média</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@API'
import DoughnutChart from '@components/graficos/DoughnutChart.vue'
import BarChart from '@components/graficos/BarChart.vue'

export default {
  props: ['status'],
  components: {
    BarChart,
    DoughnutChart
  },
  data () {
    return {
      carregando: true,
      loadingTabela: false,
      loadingRelatorio: false,
      loadingGraficoPorValor: false,
      loadingGraficoPorTempo: false,
      loadingGraficoPorMotivo: false,
      loadingGraficoPorChance: false,
      loadingGraficoPorUsuario: false,
      doughnutChartOption: {
        responsive: true,
        cutoutPercentage: 50,
        maintainAspectRatio: false,
        legend: {
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              if (!data.money) return `${data.labels[tooltipItem.index]}: ${data.datasets[0].data[tooltipItem.index]}%`
              return `${data.labels[tooltipItem.index]}: ${data.datasets[0].totalFormatado[tooltipItem.index]}`
            }
          }
        }
      },
      doughnutChartDataUsuario: null,
      doughnutChartDataValorTotal: null,
      doughnutChartDataChance: null,
      doughnutChartDataMotivo: null,
      headersUsers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        { text: 'Usuário', value: 'usuario' },
        { text: 'Qtde de oportunidadades', value: 'qtd_oportunidades' },
        { text: 'Valor total das oportunidadades', value: 'valor_total' },
        { text: 'Valor médio das oportunidadades', value: 'valor_medio' },
        { text: 'Tempo médio em aberto', value: 'tempo_medio' },
        { text: 'Chance de fechar', value: 'chances', sortable: false }
      ],
      dadosUsers: [],
      optionsChart: {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return `${value} dias`
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return `${data.datasets[0].data[tooltipItem.index]} dias`
            }
          }
        },
        legend: {
          display: false
        },
        plugins: {
          legend: {
            position: 'top'
          }
        }
      },
      chartDataTempo: null,
      chances: ['Alta', 'Média', 'Baixa'],
      chancesCores: ['#4caf50', '#ff9800', '#ff5252'],
      motivosPerda: [
        'Contato desistiu da oportunidade',
        'Contato queria saber apenas o preço',
        'Não consegue contato com o cliente',
        'Prazo de entrega',
        'Prazo de instalação',
        'Preço',
        'Problema com financiamento',
        'Outro'
      ],
      distribuidorAnterior: null,
      loadingDistribuidores: false,
      distribuidores: [],
      distribuidor: null,
      loadingIntegradores: false,
      integradores: [],
      integrador: null
    }
  },
  methods: {
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getRelatorioGeral()
    },
    async getRelatorioGeral () {
      this.loadingRelatorio = true

      let status = 'abertas'
      if (this.status === 2) {
        status = 'perdidas'
        this.headersUsers.splice(5, 1, { text: 'Tempo médio até perder a venda', value: 'tempo_medio' })
      }
      if (this.status === 3) {
        status = 'fechadas'
        this.headersUsers.splice(5, 1, { text: 'Tempo médio até fechar a venda', value: 'tempo_medio' })
      }

      let parametros = '?'
      if (this.distribuidor && !this.integrador) parametros += `distribuidor=${this.distribuidor}`
      if (this.integrador) parametros += `integrador=${this.integrador}`

      await Api.get(`oportunidades/relatorio/${status}${parametros}`)
        .then(res => {
          if (res.data) {
            const {
              quantidadePorUsuario,
              quantidadePorChance,
              quantidadePorValor,
              quantidadePorMotivo,
              tempoMedioPorUsuario,
              listaPorUsuario
            } = res.data

            this.geraGraficoPorUsuario(quantidadePorUsuario)
            this.geraGraficoPorChance(quantidadePorChance)
            this.geraGraficoPorValor(quantidadePorValor)
            this.geraGraficoPorMotivo(quantidadePorMotivo)
            this.geraGraficoPorTempo(tempoMedioPorUsuario)
            this.geraTabelaPorUsuario(listaPorUsuario)
          }
          this.loadingRelatorio = false
        })
        .catch(err => {
          console.log(err)
          this.loadingRelatorio = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o relatório!',
            color: 'error'
          })
        })
    },
    geraGraficoPorUsuario (lista) {
      if (!lista || !lista.length) return

      this.loadingGraficoPorUsuario = true
      this.doughnutChartDataUsuario = null

      let grafico = {
        labels: [],
        datasets: [
          {
            label: 'Usuário',
            backgroundColor: [],
            data: []
          }
        ]
      }

      lista.map(item => {
        if (item.usuario) {
          let label = item.usuario.usu_nome
          grafico.labels.push(label)
          grafico.datasets[0].label = label
          grafico.datasets[0].backgroundColor.push(this.generateColor())
          grafico.datasets[0].data.push(item.porcentagem)
        }
      })

      this.doughnutChartDataUsuario = grafico
      this.loadingGraficoPorUsuario = false
    },
    geraGraficoPorChance (lista) {
      if (!lista || !lista.length) return

      this.loadingGraficoPorChance = true
      this.doughnutChartDataChance = null

      let grafico = {
        labels: [],
        datasets: [
          {
            label: 'Chance',
            backgroundColor: [],
            data: []
          }
        ]
      }

      lista.map(item => {
        let label = this.chances[item.opu_probabilidade - 1]
        grafico.labels.push(label)
        grafico.datasets[0].label = label
        grafico.datasets[0].backgroundColor.push(this.chancesCores[item.opu_probabilidade - 1])
        grafico.datasets[0].data.push(item.porcentagem)
      })

      this.doughnutChartDataChance = grafico
      this.loadingGraficoPorChance = false
    },
    geraGraficoPorValor (lista) {
      if (!lista || !lista.length) return

      this.loadingGraficoPorVaor = true
      this.doughnutChartDataValorTotal = null

      let grafico = {
        labels: [],
        money: true,
        datasets: [
          {
            label: 'Valor',
            totalFormatado: [],
            backgroundColor: [],
            data: []
          }
        ]
      }

      lista.map(item => {
        if (item.usuario) {
          let label = item.usuario.usu_nome
          grafico.labels.push(label)
          grafico.datasets[0].label = label
          grafico.datasets[0].totalFormatado.push(this.$root.Formatter.floatToMoney(item.total))
          grafico.datasets[0].backgroundColor.push(this.generateColor())
          grafico.datasets[0].data.push(item.total)
        }
      })

      this.doughnutChartDataValorTotal = grafico
      this.loadingGraficoPorVaor = false
    },
    geraGraficoPorMotivo (lista) {
      if (!lista || !lista.length) return

      this.loadingGraficoPorMotivo = true
      this.doughnutChartDataMotivo = null

      let grafico = {
        labels: [],
        datasets: [
          {
            label: 'Motivo',
            backgroundColor: [],
            data: []
          }
        ]
      }

      lista.map(item => {
        let label = this.motivosPerda[item.opu_perda_motivo - 1]

        grafico.labels.push(label)
        grafico.datasets[0].label = label
        grafico.datasets[0].backgroundColor.push(this.generateColor())
        grafico.datasets[0].data.push(item.porcentagem)
      })

      this.doughnutChartDataMotivo = grafico
      this.loadingGraficoPorMotivo = false
    },
    geraGraficoPorTempo (lista) {
      if (!lista || !lista.length) return

      this.loadingGraficoPorTempo = true
      this.chartDataTempo = null

      let grafico = {
        labels: [],
        datasets: [
          {
            label: 'Tempo médio',
            fill: true,
            backgroundColor: [],
            borderColor: this.$vuetify.theme.dark ? '#B4B4B4' : '#121212',
            data: []
          }
        ]
      }

      lista.map(item => {
        let label = item.usuario.usu_nome
        grafico.labels.push(label)
        grafico.datasets[0].backgroundColor.push(this.generateColor())
        grafico.datasets[0].data.push(Math.round(item.tempo_medio))
      })

      this.chartDataTempo = grafico
      this.loadingGraficoPorTempo = false
    },
    geraTabelaPorUsuario (lista) {
      if (!lista || !lista.length) return

      this.loadingTabela = true
      this.dadosUsers = []

      lista.map(item => {
        if (item.usuario) {
          this.dadosUsers.push({
            id: item.fk_usu_id_usuario,
            usuario: item.usuario.usu_nome,
            qtd_oportunidades: item.total_oportunidades,
            valor_total: this.retornaValorEmMoeda(item.total_valor_propostas),
            valor_medio: this.retornaValorEmMoeda(item.media_valor_propostas),
            tempo_medio: this.formataDias(item.tempo_medio),
            chance_bom: item.total_chance_alta,
            chance_medio: item.total_chance_media,
            chance_baixa: item.total_chance_baixa
          })
        }
      })
      this.loadingTabela = false
    },
    formataDias (tempo) {
      const unidade = tempo > 1 ? 'dias' : 'dia'
      return `${Math.round(tempo)} ${unidade}`
    },
    retornaValorEmMoeda (valor) {
      if (!valor) return 'R$ 0,00'
      return this.$root.Formatter.floatToMoney(valor)
    },
    generateColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    async getDistributors () {
      this.loadingDistribuidores = true
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
            this.loadingDistribuidores = false
          }
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    loadFunctions () {
      if (this.$root.Permissions.admin()) {
        this.getDistributors()
        this.getIntegrators(this.distribuidor)
      }
      this.getRelatorioGeral()
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.sem_dados {
  height: 300px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/RelatorioOportunidades.vue